import type BulkActionStateStore from "../store/schema/BulkActionStateStore";
import { createStore } from "owa-satcheljs";
const initialStore: BulkActionStateStore = {
    bulkActionInformationMap: new Map(),
};

const getStore: () => BulkActionStateStore = createStore<BulkActionStateStore>("bulkActionStore", initialStore);
export default getStore;
export { getStore };
